import React from 'react';
import { Button, Avatar as MuiAvatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dropzone from 'sharedComponents/Dropzone';
import { useTranslation } from 'react-i18next';
import useUploadFile from 'reducers/hooks/useUploadFile';

import Loader from 'sharedComponents/Loader';
import useStyles from './useStyles';

const Avatar = props => {
  const { value, isSaving, onFinish, alt } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { uploadProfileImageToS3, uploadingProfileImage } = useUploadFile();

  const buildCachedImage = (fields, file) => {
    return {
      id: fields.key.match(/^cache\/(.+)/)[1],
      storage: 'cache',
      metadata: {
        size: file.size,
        filename: file.name,
        mimeType: file.type,
      },
    };
  };

  const handleOnDrop = async file => {
    const currentFile = file[0];
    const params = { type: currentFile.type, filename: currentFile.name };
    const cachedFileFields = await uploadProfileImageToS3(params, currentFile);
    const cachedVideo = buildCachedImage(cachedFileFields, currentFile);
    onFinish(cachedVideo);
  };

  const isLoading = uploadingProfileImage || isSaving;

  return (
    <div className={classes.container}>
      <div className={classes.avatar}>
        {isLoading ? <Loader /> : <MuiAvatar alt={alt} src={value} className={classes.image} variant="rounded" />}
      </div>
      <Dropzone handleOnDrop={handleOnDrop}>
        <Button className={classes.button} variant="outlined" color="primary">
          {t('components.RealEstateAgentSettingsPage.ProfileForm.Avatar.changeAvatar')}
        </Button>
      </Dropzone>
    </div>
  );
};

Avatar.propTypes = {
  value: PropTypes.string,
  isSaving: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
  alt: PropTypes.string.isRequired,
};

Avatar.defaultProps = {
  value: null,
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/components/Avatar/Avatar.js